

















































// import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { CenterSetting } from '@core/interfaces/center-setting';
import store from '@app/store';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import CustomContactFieldsHelper from './helpers/custom-contact-fields-helper';

library.add(faPlus);

@Component({
  name: 'bpc-center-settings',
  components: {
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-std-form': StdForm,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
  },
})
export default class CenterSettings extends Vue {
  $refs!: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & { saveEntity(): void; formModel: any };
    deleteMediaFileConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };

  public showEditForm: boolean = false;

  /**
   * Form
   */
  centerSetting: CenterSetting = new CenterSetting();

  /* Lifecycle hooks */

  created() {
    this.onEdit();
  }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  onEdit() {
    this.centerSetting = new CenterSetting();
    this.showEditForm = true;
    this.centerSetting.id = store.getters['tenant/selectedTenant'].center_setting.id; // We have to determine the option id of the current center
  }

  onEditFormSave() {
    console.log('Saving');
    const customContactFields = CustomContactFieldsHelper.prepareCustomContactFields(
      this.$refs.stdForm.formModel,
    );
    this.$refs.stdForm.formModel.custom_contact_fields = customContactFields;
    this.$refs.stdForm.saveEntity();
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.$store.commit('centerSettings/updateCenterSettings', this.$refs.stdForm.formModel);
    this.$router.go(null);
  }

  getModalTitle() {
    return 'Edit Center Settings';
  }

  getDeleteMediaFileConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'media-file-delete-modal',
      title: this.$t('global.modals.media-delete.title') as string,
      body: this.$t('global.modals.media-delete.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.permanent_delete') as string,
      acceptButtonVariant: 'danger',
    };
  }

  onSuccessMediaFileDelete() {
    this.$refs.deleteMediaFileConfirmationModal.onCloseModal();
  }

  showDeleteMediaFileModal(mediaId: string) {
    this.$refs.deleteMediaFileConfirmationModal.onOpenModal(mediaId);
  }
}
